import CurrencyConst from "../consts/CurrencyConst";
import CurrencyUtility from "./currency-utility/CurrencyUtility";

const EuroUtility = {
    convert(value: any): string {
        if (!value)
            return '';

        const result = this.convertCurrency(value, CurrencyUtility.getPrimary().id);
        return result;
    },
    convertCurrency(value: any, currencyId: number): string {
        if (!value)
            return '0,00';

        let result;

        const currency = CurrencyUtility.getPrimaryCurrencyById(currencyId);

        if (currency === CurrencyConst.Euro)
            result = value * this.rate;
        else
            result = value / this.rate;

        result = result.toFixed(2).toString().replace('.', ',');

        return result;
    },
    rate: 7.53450
};

export default EuroUtility;